import React from "react";
import { useNavigate } from "react-router-dom";
import "./Card.css";

function Card() {
  const navigate = useNavigate();

  return (
    <div className="card-page">
      {/* Header */}
      <div className="card-header">
        <button className="card-back" type="button" onClick={() => navigate("/")}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f0f2f5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span className="card-title">Card</span>
        <span style={{ width: 22 }} />
      </div>

      {/* Visa Card */}
      <div className="card-visa-card">
        <div className="bvc-top">
          <span className="bvc-brand">eToro</span>
          <span className="bvc-tier">◆ DIAMOND</span>
        </div>
        <div className="bvc-chip" />
        <div className="bvc-number">•••• •••• •••• 4242</div>
        <div className="bvc-bottom">
          <div>
            <div className="bvc-holder-label">CARD HOLDER</div>
            <div className="bvc-holder-name">YONI ASSIA</div>
          </div>
          <span className="bvc-visa">VISA</span>
        </div>
      </div>

      {/* Balance */}
      <div className="card-balance">
        <span className="card-balance-label">Available Balance</span>
        <span className="card-balance-value">$12,450.00</span>
      </div>



      {/* DIGITAL CARD */}
      <div className="card-section">
        <div className="card-section-title">DIGITAL CARD</div>
        <div className="card-section-rows">
          {/* Physical Card */}
          <button className="card-row" type="button" onClick={() => navigate("/physical-card")}>
            <span className="card-row-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="5" width="20" height="14" rx="2"/>
                <line x1="2" y1="10" x2="22" y2="10"/>
              </svg>
            </span>
            <div className="card-row-label-wrap">
              <span className="card-row-label">Physical Card</span>
              <span className="card-row-sub">Available from Gold & above</span>
            </div>
            <span className="card-row-right">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </button>
          {/* Apple Pay */}
          <button className="card-row" type="button" onClick={() => navigate("/apple-pay")}>
            <span className="card-row-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
            </span>
            <div className="card-row-label-wrap">
              <span className="card-row-label">Apple Pay</span>
              <span className="card-row-sub">Tap to pay everywhere</span>
            </div>
            <span className="card-row-right">
              <span className="card-badge card-badge-green">LIVE</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </button>
        </div>
      </div>

      {/* FAMILY */}
      <div className="card-section">
        <div className="card-section-title">FAMILY</div>
        <div className="card-section-rows">
          <button className="card-row" type="button">
            <span className="card-row-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 00-3-3.87"/>
                <path d="M16 3.13a4 4 0 010 7.75"/>
              </svg>
            </span>
            <span className="card-row-label">Family Cards</span>
            <span className="card-row-right">
              <span className="card-badge card-badge-muted">SOON</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </button>
        </div>
      </div>

      {/* CARD CONTROLS */}
      <div className="card-section">
        <div className="card-section-title">CARD CONTROLS</div>
        <div className="card-section-rows">
          <button className="card-row" type="button">
            <span className="card-row-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0110 0v4"/>
              </svg>
            </span>
            <span className="card-row-label">Freeze Card</span>
            <span className="card-row-right">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </button>
          <button className="card-row" type="button">
            <span className="card-row-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="5" width="20" height="14" rx="2"/>
                <line x1="2" y1="10" x2="22" y2="10"/>
              </svg>
            </span>
            <span className="card-row-label">Issue Card</span>
            <span className="card-row-right">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </button>
          <button className="card-row" type="button">
            <span className="card-row-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0110 0v4"/>
              </svg>
            </span>
            <span className="card-row-label">Spending Limits</span>
            <span className="card-row-right">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </button>
          <button className="card-row" type="button">
            <span className="card-row-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                <path d="M13.73 21a2 2 0 01-3.46 0"/>
              </svg>
            </span>
            <span className="card-row-label">Transaction Alerts</span>
            <span className="card-row-right">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </button>
          <button className="card-row" type="button">
            <span className="card-row-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
            </span>
            <span className="card-row-label">Travel Mode</span>
            <span className="card-row-right">
              <span className="card-badge card-badge-green">On</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </button>
        </div>
      </div>

      {/* TRANSFERS */}
      <div className="card-section">
        <div className="card-section-title">TRANSFERS</div>
        <div className="card-section-rows">
          <button className="card-row" type="button">
            <span className="card-row-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="1" x2="12" y2="23"/>
                <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
              </svg>
            </span>
            <span className="card-row-label">Send Money Abroad</span>
            <span className="card-row-right">
              <span className="card-badge card-badge-muted">Wise</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </button>
          <button className="card-row" type="button">
            <span className="card-row-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="23 4 23 10 17 10"/>
                <polyline points="1 20 1 14 7 14"/>
                <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/>
              </svg>
            </span>
            <span className="card-row-label">Currency Exchange</span>
            <span className="card-row-right">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </button>
          <button className="card-row" type="button">
            <span className="card-row-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
              </svg>
            </span>
            <span className="card-row-label">Visa Direct</span>
            <span className="card-row-right">
              <span className="card-badge card-badge-green">Instant</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </button>
        </div>
      </div>

      {/* STATEMENTS */}
      <div className="card-section">
        <div className="card-section-title">STATEMENTS</div>
        <div className="card-section-rows">
          <button className="card-row" type="button">
            <span className="card-row-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
              </svg>
            </span>
            <span className="card-row-label">Monthly Statements</span>
            <span className="card-row-right">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </button>

        </div>
      </div>

      <div style={{ height: 100 }} />
    </div>
  );
}

export default Card;
